module.exports = __webpack_public_path__ + "img/the-header-logo.53b9b6b1.png";